import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6" data-testid="not-found-page">
      <Compass className="w-10 h-10 text-muted-foreground mb-4" />
      <h1 className="font-heading text-4xl font-black tracking-tight">Page not found</h1>
      <p className="text-muted-foreground mt-2 max-w-md">That route doesn't exist. Let's get you back to the squad.</p>
      <Link to="/" data-testid="notfound-home-link" className="mt-6 text-sm bg-foreground text-background px-4 py-2 hover:bg-neutral-800 transition-colors">Back to Command Center</Link>
    </div>
  );
}
